<template>
  <!-- Off-canvas menu for mobile -->
  <div v-if="!sidebar" class="lg:hidden fixed z-40">
    <div class="fixed inset-0 flex z-40">
      <transition
        enter-active-class="transition-opacity ease-linear duration-300"
        leave-active-class="transition-opacity ease-linear duration-300"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div v-if="sidebarTransition" class="fixed inset-0">
          <div class="absolute inset-0 bg-slate-900 opacity-75" @click="hideSidebar"></div>
        </div>
      </transition>

      <transition
        enter-active-class="transition ease-in-out duration-300 transform"
        leave-active-class="transition ease-in-out duration-300 transform"
        enter-class="-translate-x-full"
        enter-to-class="translate-x-0"
        leave-class="translate-x-0"
        leave-to-class="-translate-x-full"
      >
        <div v-if="sidebarTransition" class="relative flex-1 flex flex-col max-w-xs w-full bg-slate-900">
          <div class="absolute top-0 right-0 -mr-14 p-1">
            <button
              class="flex items-center justify-center h-12 w-12 rounded-full focus:outline-none focus:bg-gray-600"
              aria-label="Close sidebar"
              @click="hideSidebar"
            >
              <svg class="h-6 w-6 text-white" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div class="flex-1 h-0 pt-5 pb-4 overflow-y-auto">
            <div class="flex-shrink-0 flex items-center px-8 text-white">
              <new-logo />
            </div>
            <nav class="mt-5 space-y-1">
              <div v-if="agentView === false">
                <div class="p-8 border-b border-slate-700">
                  <router-link
                    to="/"
                    class="flex items-center text-slate-300 hover:text-slate-100 px-2 py-2 rounded-lg"
                  >
                    <vue-feather type="home" class="h-4 mr-1" />
                    Dashboard
                  </router-link>
                  <router-link
                    v-if="$store.state.general.currentUserAccountDetails.role == 'Admin'"
                    to="/jobs?sort=created&order=desc&status=Active"
                    class="flex items-center mt-3 text-slate-300 hover:text-slate-100 px-2 py-2 rounded-lg"
                  >
                    <vue-feather type="bookmark" class="h-4 mr-1" />
                    Jobs
                  </router-link>
                  <router-link
                    to="/contacts?sort=created&order=desc"
                    class="flex items-center mt-3 text-slate-300 hover:text-slate-100 px-2 py-2 rounded-lg"
                  >
                    <vue-feather type="users" class="h-4 mr-1" />
                    Candidates
                  </router-link>
                </div>
                <div class="p-8">
                  <router-link
                    to="/team?status=Active&sort=created&order=desc"
                    class="flex items-center text-slate-300 hover:text-slate-100 px-2 py-2 rounded-lg"
                  >
                    <vue-feather type="life-buoy" class="h-4 mr-1" />
                    Team
                  </router-link>
                  <router-link
                    to="/settings"
                    class="flex items-center mt-3 text-slate-300 hover:text-slate-100 px-2 py-2 rounded-lg"
                  >
                    <vue-feather type="settings" class="h-4 mr-1" />
                    Settings
                  </router-link>
                </div>
              </div>
              <div v-else class="p-8">
                <router-link
                  to="/agents/onboarding"
                  class="flex items-center text-slate-300 hover:text-slate-100 px-2 py-2 rounded-lg"
                >
                  <vue-feather type="home" class="h-4 mr-1" />
                  Onboarding
                </router-link>
              </div>
              <div class="p-8 border-t border-slate-700">
                <div class="flex items-center w-full">
                  <router-link v-if="$store.state.general.teamSetupProgress >= 100" to="/settings/account/profile">
                    <div class="h-8 w-8 mr-3 rounded-full flex items-center justify-center bg-[#fde68a] text-slate-900">
                      {{ $store.state.general.currentUserAccountDetails.username.charAt(0).toUpperCase() }}
                    </div>
                  </router-link>
                  <router-link v-else to="/settings">
                    <RadialProgress
                      class="text-white mr-2"
                      style="--size: 2rem; font-size: 0.5rem"
                      :progress="$store.state.general.teamSetupProgress"
                    />
                  </router-link>
                  <div class="flex flex-col text-left text-sm text-white text-ellipsis overflow-hidden">
                    {{ $store.state.general.currentUserAccountDetails.username }}
                    <div
                      class="cursor-pointer inline-block text-xs leading-4 font-medium text-slate-400 group-hover:text-gray-700 transition ease-in-out duration-150"
                      @click="signOut"
                    >
                      Sign out
                    </div>
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </transition>
      <div class="flex-shrink-0 w-14">
        <!-- Force sidebar to shrink to fit close icon -->
      </div>
    </div>
  </div>
</template>

<script>
import RadialProgress from '../../shared/RadialProgress.vue';
import NewLogo from '../../hummer/onboarding/Navbar/Logo.vue';
export default {
  components: {
    RadialProgress,
    NewLogo,
  },
  data() {
    return {
      sidebar: true,
      sidebarTransition: false,
    };
  },
  computed: {
    agentView() {
      return this.$store.state.general.currentUserAccountDetails.role === 'Agent';
    },
  },
  methods: {
    showSidebar() {
      const self = this;
      self.sidebar = false;
      setTimeout(() => {
        self.sidebarTransition = true;
      }, 25);
    },
    hideSidebar() {
      const self = this;
      setTimeout(() => {
        self.sidebarTransition = false;
      }, 25);
      setTimeout(() => {
        self.sidebar = true;
      }, 325);
    },
    signOut() {
      fetch('/users/sign_out', {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {})
        .then(data => {
          window.location.href = '/';
        });
    },
  },
};
</script>

<!-- duplicated in NewLayout -->
<style scoped>
@reference "tailwindcss";
.router-link-exact-active.router-link-active {
  @apply bg-slate-800 font-bold text-white;
}
</style>
